/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';
import RichTextItem from 'shared/components/RichTextItem';
import { EditorState } from 'draft-js';
import { htmlToState, linkDecorator, getCharCount } from 'utils/richtext';

type Props = {
  block: EditorialTextBlock,
};

const View = ({ block }: Props) => {
  const stateFromBlockContent = block.content
    ? htmlToState(block.content)
    : EditorState.createEmpty(linkDecorator);

  if (getCharCount(stateFromBlockContent)) {
    return <RichTextItem parentState={stateFromBlockContent} readOnly />;
  }

  return <Message icon="info" header="Element texte vide" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/text/View.js